import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import { getSettingsEditing } from 'client/reducers/managementReducer'
import { useManagement, useWebsiteSettings } from 'client/store'
import React from 'react'
import { getWebsiteStylesTypographyHeading } from 'src/editor/store/website-settings/website-settings-selector'
import { CommonForm } from 'src/shared/entities/form'
import { FormSubEntityTypeEnum } from 'src/shared/entities/form/enums'
import { FormInterface } from 'src/shared/entities/form/form.schema'
import { useCalculateTypography } from '../../hooks/use-calculate-typography'
import { FormCheckboxSubEntity } from './form-checkbox-sub-entity'
import { FormFieldSubEntity } from './form-field-sub-entity'
import { FormSubmitButtonSubEntity } from './form-submit-button-sub-entity'

export interface FormProps {
  entity: FormInterface
  isMoveUpAllowed: boolean
  isMoveDownAllowed: boolean
}

export const Form = ({
  entity,
  isMoveUpAllowed,
  isMoveDownAllowed,
}: FormProps) => {
  const { calculatedFontSize } = useCalculateTypography()

  const {
    fontSize: websiteGlobalHeadingFontSize,
    mobileFontSize: websiteGlobalMobileHeadingFontSize,
  } = useWebsiteSettings(getWebsiteStylesTypographyHeading) || {}

  const { areSuccessOptInScreenSettingsOpened } =
    useManagement(getSettingsEditing) || {}
  return (
    <BaseEntityNew
      entity={entity}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
    >
      <CommonForm
        entity={entity}
        successOptInScreen={{
          fontSize: calculatedFontSize.desktop,
          mobileFontSize: calculatedFontSize.mobile,
          headerFontSize: websiteGlobalHeadingFontSize,
          headerMobileFontSize: websiteGlobalMobileHeadingFontSize,
          textColor: entity.action.successOptInScreen?.textColor,
          mobileTextColor: entity.action.successOptInScreen?.mobileTextColor,
        }}
        isSuccessOptInScreenOpened={areSuccessOptInScreenSettingsOpened}
      >
        {entity.subEntities.map(subEntity => {
          if (subEntity.type === FormSubEntityTypeEnum.Field) {
            return (
              <FormFieldSubEntity
                key={subEntity.id}
                formEntity={entity}
                fieldSubEntity={subEntity}
              />
            )
          } else if (subEntity.type === FormSubEntityTypeEnum.Checkbox) {
            return (
              <FormCheckboxSubEntity
                key={subEntity.id}
                formEntity={entity}
                checkboxSubEntity={subEntity}
              />
            )
          } else {
            return (
              <FormSubmitButtonSubEntity
                key={subEntity.id}
                formEntity={entity}
                submitButtonSubEntity={subEntity}
              />
            )
          }
        })}
      </CommonForm>
    </BaseEntityNew>
  )
}
